import { Component, OnInit } from '@angular/core';
import {UtilitiesService} from "../../../common/service/utilities.service";

@Component({
  selector: 'app-uis',
  templateUrl: './uis.component.html',
  styleUrls: ['./uis.component.scss']
})
export class UisComponent implements OnInit {

  constructor(private util:UtilitiesService) { }

  ngOnInit() {

  }

}
